export const legacyGamesDestination = search => {
  const tab = new URLSearchParams(search).get('tab');
  return ['match-play', 'skins', 'stroke-play'].includes(tab)
    ? `/tournaments/${tab}` : '/tournaments';
};